
import React from "react";
import { AutoComplete, Button, Card, Col, DatePicker, Form, Row, Select, Spin, Switch } from "antd";

const { Option } = Select;

const CustomerDetailsReport = ({
  loginPlaceId,
  districts,
  branches,
  wasams,
  depositsProducts,
  loanProducts,
  branchesForDivArea,
  selectedDistricts,
  handleDistrictsChange,
  setSelectedBranches,
  selectedWasams,
  handleWasamChange,
  selectedDepositProducts,
  handleDepositProductChange,
  selectedLoanProducts,
  handleLoanProductChange,
  selectedCustomerStatus,
  setSelectedCustomerStatus,
  selectedCustomerNumbersByNumber,
  setSelectedCustomerNumbersByNumber,
  handleCustomerSearch,
  handleCustomerNameChange,
  selectedCustomerNumbersByName,
  customerSearchResults,
  isExcelCustomerReport,
  setIsExcelCustomerReport,
  selectedDates,
  generateCustomerDetailsReport,
  customerDetailsLoading
}) => {
  return (

    <Card hoverable className="inner-card">
        <Form layout="vertical">
            <Row gutter={[16, 16]} justify="space-around">

                {(loginPlaceId === "3") && (
                    <Col span={24}>
                        <Form.Item label="Select District">
                            <Select
                                value={selectedDistricts}
                                onChange={handleDistrictsChange}
                                style={{ width: "100%" }}
                            >
                                {districts?.map((district) => (
                                    <Option key={district.districtId} value={district.districtId}>
                                        {district.districtName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                )}

                {(loginPlaceId === "3" || loginPlaceId === "4") && (
                    <Col span={24}>
                        <Form.Item label="Select Branch">
                            <Select
                                mode="multiple"
                                 onChange={(value) => setSelectedBranches(value)}
                                style={{ width: "100%" }}
                            >
                                {branches?.map((branch) => (
                                    <Option key={branch.id} value={branch.id}>
                                        {branch.branchName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                )}

                {(loginPlaceId === "2") && (
                    <Col span={24}>
                        <Form.Item label="Select Branch">
                            <Select
                                mode="multiple"
                                onChange={(value) => setSelectedBranches(value)}
                                style={{ width: "100%" }}
                            >
                               {branchesForDivArea?.map((branch) => (
                                    <Option key={branch.id} value={branch.id}>
                                        {branch.branchName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                )}

                {(loginPlaceId === "1" || loginPlaceId === "2" || loginPlaceId === "3" || loginPlaceId === "4") && (
                    <Col span={24}>
                    <Form.Item label="Select Wasam">
                        <Select
                        mode="multiple"
                        value={selectedWasams}
                        onChange={(values) => {
                            if (values.includes(0)) {
                            if (selectedWasams.length !== wasams.length) {
                                handleWasamChange(wasams.map((w) => w.wastId));
                            } else {
                                handleWasamChange([]);
                            }
                            } else {
                            handleWasamChange(values);
                            }
                        }}
                        style={{ width: "100%" }}
                        >
                        <Option value={0}>All</Option>
                        {wasams?.map((wasam) => (
                            <Option key={wasam.wastId} value={wasam.wastId}>
                            {wasam.wasName}
                            </Option>
                        ))}
                        </Select>
                    </Form.Item>
                    </Col>

                )}

                <Col span={24}>
                    <Form.Item label="Customer Status">
                        <Select
                            onChange={(value) => setSelectedCustomerStatus(value)}
                            style={{ width: '100%' }}
                        >
                            <Option value={0}>Active</Option>
                            <Option value={1}>InActive</Option>
                            <Option value={2}>All</Option>
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="Select Customer Number">
                        <Select
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder="Type and press Enter to add customer numbers"
                            value={selectedCustomerNumbersByNumber}
                            onChange={setSelectedCustomerNumbersByNumber}
                            tokenSeparators={[' ']}
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="Select Customer Name">
                        <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Type customer name"
                            showSearch
                            onSearch={handleCustomerSearch}
                            onChange={handleCustomerNameChange}
                            value={selectedCustomerNumbersByName}
                            filterOption={false}
                            labelInValue
                        >
                            {customerSearchResults.map((customer) => (
                                <Select.Option key={customer.cusNo} value={customer.value}>
                                    {customer.label}- {customer.cusNo}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={24}>
                <Form.Item label="Deposit Product">
                    <Select
                    mode="multiple"
                    value={selectedDepositProducts}
                    onChange={(values) => {
                        if (values.includes(0)) {
                        if (selectedDepositProducts.length !== depositsProducts.length) {
                            handleDepositProductChange(depositsProducts.map((p) => p.productId));
                        } else {
                            handleDepositProductChange([]);
                        }
                        } else {
                        handleDepositProductChange(values);
                        }
                    }}
                    style={{ width: '100%' }}
                    >
                    <Option value={0}>All</Option>
                    {depositsProducts?.map((product) => (
                        <Option key={product.productId} value={product.productId}>
                        {product.productCode}-{product.productName}
                        </Option>
                    ))}
                    </Select>
                </Form.Item>
                </Col>


                <Col span={24}>
                <Form.Item label="Loan Product">
                    <Select
                    mode="multiple"
                    value={selectedLoanProducts}
                    onChange={(values) => {
                        if (values.includes(0)) {
                        if (selectedLoanProducts.length !== loanProducts.length) {
                            handleLoanProductChange(loanProducts.map((p) => p.productId));
                        } else {
                            handleLoanProductChange([]);
                        }
                        } else {
                        handleLoanProductChange(values);
                        }
                    }}
                    style={{ width: '100%' }}
                    >
                    <Option value={0}>All</Option>
                    {loanProducts?.map((product) => (
                        <Option key={product.productId} value={product.productId}>
                        {product.productCode}-{product.productName}
                        </Option>
                    ))}
                    </Select>
                </Form.Item>
                </Col>
                {/* toggle button(enable if pdf is needed) */}
                {/* <Col span={24}>
                    <Form.Item label="Generate Excel Sheet">
                        <Switch defaultChecked={true} disabled onChange={setIsExcelCustomerReport} />
                    </Form.Item>
                </Col> */}

                <Col span={24} style={{ textAlign: 'right' }}>
                    <Form.Item className="generate-btn-outline">
                        <Button
                            className="generate-btn"
                            onClick={generateCustomerDetailsReport}
                            disabled={!selectedDates || customerDetailsLoading}
                        >
                            {customerDetailsLoading ? <Spin /> : 'Generate Report'}
                        </Button>
                    </Form.Item>
                </Col>

            </Row>
        </Form>
    </Card>

  );
};

export default CustomerDetailsReport;
